<template>
    <div class="row workorder">
        <div class="col-md-2 first-col filter d-none d-md-inline-block">
            <datepicker v-model="pagination.selectedDate" :monday-first="true" language="hr" :full-month-name="true" format="dd.MM.yyyy" :inline="true"></datepicker>
            <div class="block tasks-filter">
                <h3>{{$t('FILTERTASKS')}}</h3>
                <div class="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>{{$t('NAME')}}</th>
                                <th>{{$t('TASKFROM')}}</th>
                                <th>{{$t('TASKTO')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-bind:class="(pagination.userFrom == false || pagination.userTo == false) ? 'selected' : ''">{{$t('ALLWORKERS')}}</td>
                                <td>
                                    <b-form-checkbox class="grey" v-model="pagination.userFrom" v-bind:value="false"></b-form-checkbox>
                                </td>
                                <td>
                                    <b-form-checkbox class="grey" v-model="pagination.userTo" v-bind:value="false"></b-form-checkbox>
                                </td>
                            </tr>
                            <tr v-for="user in taskUsers.root">
                                <td v-bind:class="(user.userId == pagination.userFrom || user.userId == pagination.userTo) ? 'selected' : ''">{{user.nameSurname}}</td>
                                <td>
                                    <b-form-checkbox class="grey" v-model="pagination.userFrom" v-bind:value="user.userId"></b-form-checkbox>
                                </td>
                                <td>
                                    <b-form-checkbox class="grey" v-model="pagination.userTo" v-bind:value="user.userId" v-bind:checked="pagination.userTo == user.userId"></b-form-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-md-10 col-12 last-col">

            <div class="table-responsive">
                <div class="header-info">
                    <div class="col-md-12"><b>{{$t('ALLTASKSFOR')}} {{formatedDate}}</b></div>
                 </div>
                <table class="maintable smaller nopadding">
                    <thead>
                        <tr>
                            <th class="d-none d-md-table-cell">{{$t('TASKFROM')}}</th>
                            <th class="d-none d-md-table-cell">{{$t('TASKTO')}}</th>
                            <th>{{$t('PACIENT')}}</th>
                            <th>{{$t('TIME')}}</th>
                            <th>{{$t('NOTICE')}}</th>
                            <th>{{$t('FINISHED')}}</th>
                            <th class="d-none d-md-table-cell">{{$t('OPENEDON')}}</th>
                            <th class="d-none d-md-table-cell">{{$t('LASTCHANGE')}}</th>
                            <th class="d-none d-md-table-cell center">{{$t('WORKFORM')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="task in tasks.root">
                            <td class="d-none d-md-table-cell"><a v-on:click.prevent="startChatByUserId(task.userId, task.workOrderId)"><img src="../assets/img/chat-name-icon-blue.svg" alt="" /> {{task.name}} {{task.surname}}</a></td>
                            <td class="d-none d-md-table-cell"><a v-on:click.prevent="startChatByUserId(task.toUserId, task.workOrderId)"><img src="../assets/img/chat-name-icon-blue.svg" alt="" /> {{task.toName}} {{task.toSurname}}</a></td>
                            <td>
                                <router-link v-if="task.workOrderId" :to="{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}">{{task.patientName}} {{task.patientSurname}}</router-link>
                                <router-link v-if="task.dentalSolutionId" :to="{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}">{{task.dentalSolutionId}}</router-link>
                            </td>
                            <td>{{formatDate(task.deadline)}}</td>
                            <td>
                                <router-link v-if="task.workOrderId" :to="{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}">{{task.text}}</router-link>
                                <router-link v-if="task.dentalSolutionId" :to="{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}">{{task.text}}</router-link>
                            </td>
                            <td>
                                <input-switch v-bind:checked="task.status == 'finished'" v-bind:id="task.workOrderTaskId" v-on:change="toggleTask"></input-switch>
                            </td>
                            <td class="d-none d-md-table-cell">{{formatDate(task.insertDateTime)}}</td>
                            <td class="d-none d-md-table-cell">{{formatDate(task.updateDateTime)}}</td>
                            <td class="d-none d-md-table-cell center">
                                <router-link v-if="task.workOrderId" :to="{ path: '/workorders/'+task.workOrderId, query: { open: 'tasks' }}"><img src="../assets/img/icon-nalog-blue.svg" /></router-link>
                                <router-link v-if="task.dentalSolutionId" :to="{ path: '/dentalsolutions/'+task.dentalSolutionId, query: { open: 'tasks' }}"><img src="../assets/img/icon-nalog-blue.svg" /></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <b-pagination align="center" v-if="tasks.totalCount > 20" :total-rows="tasks.totalCount" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
        </div>
    </div>
</template>

<script>

import
{
    mapGetters,
    mapActions
}
from 'vuex'
import workOrderTasksApi from '@/api/workordertasks'
var moment = require('moment');

export default
{
    name: 'Tasks',
    data: function()
    {
        return {
            checkedVal: false,
            taskUsers:
            {},
            tasks:
            {},
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                userFrom: false,
                userTo: false,
                selectedDate: null,
            }
        };
    },
    created: function()
    {
        var me = this;
        me.pagination.userTo = me.globals.userId;
        me.getUsers();
        me.getTasksByFromTo();
    },
    methods:
    {
        getStatusBool: function(status)
        {
            var me = this;
            if (status == 'finished') return true;
            return false;
        },
        toggleTask: function(val, workOrderTaskId)
        {
            var me = this;
            workOrderTasksApi.toggleTask(
            {
                workOrderTaskId: workOrderTaskId,
                checked: val
            }, function(data)
            {
                if (data.error && data.error == true)
                {
                    me.$notify.error(data.notice);
                }
                me.getTasksByFromTo();
            });
        },
        formatTime: function(deadline)
        {
            var me = this;
            return moment(deadline).format('HH:mm');
        },
        formatDate: function(date)
        {
            var me = this;
            return moment(date).format('DD.MM.YYYY. HH:mm');
        },
        getUsers: function()
        {
            var me = this;
            workOrderTasksApi.getFromAndToUsers(
            {}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.taskUsers = data;
            });
        },
        getTasksByFromTo: function()
        {
            var me = this;
            me.tasks = {};
            workOrderTasksApi.getTasksByFromTo(me.getParams, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }

                me.tasks = data;
            });
        }
    },
    watch:
    {
        'pagination.query': function()
        {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.userFrom': function()
        {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.currentPage': function(newValue, oldValue)
        {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.userTo': function()
        {
            var me = this;
            me.getTasksByFromTo();
        },
        'pagination.selectedDate': function(newValue, oldValue)
        {
            var me = this;
            if (oldValue != null && typeof oldValue == 'object' && newValue != null && typeof newValue == 'object' && oldValue.getTime() == newValue.getTime()) me.pagination.selectedDate = null;
            else me.getTasksByFromTo();
        }
    },
    computed:
    {
        ...mapGetters([
            'globals'
        ]),
        formatedDate()
        {
            var me = this;
            if (me.pagination.selectedDate == null) return '*';
            return moment(me.pagination.selectedDate).format('DD.MM.YYYY')
        },
        getParams: function()
        {
            var me = this;
            var data = Object.assign(
            {}, me.pagination,
            {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Tasks.vue